import { createAction, props } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  DocumentEditorNotification,
  DocumentEditorType,
  DocumentInfo,
  EditorEditItem,
  StoreWidgetErrorId,
  UiWidget,
  ViewMode,
  WidgetNotification, WidgetState
} from '@pt/pt-models';
import { WidgetStatus } from '../../widget-status';
import { CommonDocumentEditorDetails } from '@primatoo-ms-organization';
import { GetChapterResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/GetChapterResponse';
import { Chapter } from 'it/primatoo/openapi/api/org/schemas/common/docs/_listtemplatechapterresponse/Chapter';
import {
  ListTemplateChapterResponse
} from 'it/primatoo/openapi/api/org/schemas/common/docs/ListTemplateChapterResponse';
import { SetChapterStatusRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/SetChapterStatusRequest';
import {
  DisableTreatmentWarningRequest
} from 'it/primatoo/openapi/api/org/schemas/treatment/DisableTreatmentWarningRequest';
import { TreatmentWarning } from 'it/primatoo/openapi/api/org/schemas/treatment/TreatmentWarning';
import { AvailableOperations } from 'it/primatoo/openapi/api/org/schemas/common/AvailableOperations';
import { Widget } from 'it/primatoo/openapi/api/org/schemas/common/docs/Widget';
import { UpsertWidgetsRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/UpsertWidgetsRequest';
import { ChapterSelector } from 'it/primatoo/openapi/api/org/schemas/common/docs/ChapterSelector';


export const activeLiaChapter = createAction('[Editor] Active LiaChapter');

export const setViewMode = createAction('[Editor] setViewMode', props<{ viewMode: ViewMode }>());

export const reloadEditorDetails = createAction('[Editor] Reload editor details');
export const reloadEditorDetailsSuccess = createAction('[Editor] Reload editor details SUCCESS', props<{
  details: CommonDocumentEditorDetails
}>());
export const reloadEditorDetailsFailed = createAction('[Editor] Reload editor details FAILED');

export const loadChapters = createAction('[Editor] loadChapters');
export const loadChaptersSuccess = createAction('[Editor] loadChapters SUCCESS', props<{
  listTemplateChapter: ListTemplateChapterResponse
}>());
export const loadChaptersFailed = createAction('[Editor] loadChapters FAILED');

export const reopenDocument = createAction('[Widget] Reopen Document', props<{ id: number, docType: string }>());

export const userCheckTrueInPublishedDocument = createAction('[Widget] User Check true in Published document', props<{
  document: CommonDocumentEditorDetails
}>());
export const userCheckTrueInDraftDocument = createAction('[Widget] User Check true in Draft document', props<{
  docId: number
}>());

export const upsertWidgetEnabled = createAction('[Widget] upsert widget enabled', props<{ request: UpsertWidgetsRequest }>());

export const cleanAll = createAction('[Widget] Clean all');

export const notifyError = createAction('[Widget] Notify Error', props<{
  id: StoreWidgetErrorId,
  message: Observable<string>
}>());

export const setWidgetState = createAction('[Widget] Set Widget State', props<{ widgetStatus: WidgetStatus }>());

export const execTriggerWidget =
  createAction('[Widget] Exec Trigger Widget', props<{ widget: UiWidget, resetWarning: TreatmentWarning[] }>());

export const saveWidgets = createAction('[Widget] Save Widgets', props<{
  widgets: Widget[],
  initialization?: boolean,
  resetWarning?: TreatmentWarning[],
  activeChapter?: ChapterSelector[]
}>());
export const saveDocInfo = createAction('[Widget] Save Doc Info', props<{ docInfo?: DocumentInfo }>());
export const loadDocumentPermission = createAction('[Widget] loadDocument Permission', props<{
  docId: number,
  docType: DocumentEditorType
}>());
export const loadDocumentPermissionSuccess = createAction('[Widget] loadDocument Permission Success', props<{
  operations: AvailableOperations
}>());
export const loadDocumentPermissionFailed = createAction('[Widget] loadDocument Permission Failed');


export const reloadWidget = createAction('[Widget] Reload Widgets', props<{ widgets: UiWidget[] }>());
export const reloadWidgetAfterSave = createAction('[Widget] Reload Widgets reloadWidgetAfterSave', props<{
  widgets: UiWidget[]
}>());
export const reloadedResult = createAction('[Editor] Reloaded result');
export const forceReloadedResult = createAction('[Editor] Forge Reloaded result');

export const setEditorEditItemState = createAction('[Widget] Set editor edit item', props<{ item: EditorEditItem }>());
export const resetEditorEditItemState = createAction('[Widget] Reset editor edit item');

export const saveWidgetFromExternalRequest = createAction('[Widget] Save Widget using external request', props<{
  internalId: number
}>());
export const saveWidgetValidation = createAction('[Widget] Save Widget Validation', props<{
  internalId: number,
  valid: boolean
}>());

export const removeEditWidgetId = createAction('[Widget] Remove edit widget id');


export const loadChapter = createAction('[Editor] Load Chapter', props<{ docId: number, chapter: Chapter }>());
export const loadChapterSuccess = createAction('[Editor] Load Chapter SUCCESS', props<{
  chapter: GetChapterResponse
}>());
export const loadChapterFailed = createAction('[Editor] Load Chapter FAILED');


export const initializeChapter = createAction('[Widget] Global Initialization Chapter', props<{
  chapter: GetChapterResponse
}>());
export const initializeChapterSuccess = createAction('[Widget] Global Initialization Template Chapter SUCCESS', props<{
  chapter: GetChapterResponse
}>());
export const initializeChapterFailed = createAction('[Widget] Global Initialization Template Chapter FAILED');

export const emitDocumentEditorNotification = createAction('[Widget] Emit Document Editor Notification', props<{
  data: DocumentEditorNotification
}>());
export const clearDocumentEditorNotifications = createAction('[Widget] Clear Document Editor Notifications');
export const emitWidgetNotification = createAction('[Widget] Emit Widget Notification', props<{
  notification: WidgetNotification
}>());
export const clearWidgetNotifications = createAction('[Widget] Clear Widget Notifications');
export const setChapterStatus = createAction('[Editor] Set chapter status', props<{
  docId: number,
  chapterId: number,
  request: SetChapterStatusRequest
}>());
export const setChapterStatusSuccess = createAction('[Editor] Set chapter status SUCCESS', props<{
  docId: number,
  chapterId: number,
  request: SetChapterStatusRequest
}>());

export const disableWarnings = createAction('[Editor] disableWarnings', props<{
  request: DisableTreatmentWarningRequest
}>());
export const reloadWarnings = createAction('[Editor] reloadWarnings');
export const reloadWarningsSuccess = createAction('[Editor] reloadWarnings Success', props<{
  warnings: Array<TreatmentWarning>
}>());

// DA RIMUOVERE
export const setLanguage = createAction('[Widget] Set language', props<{ language: string }>());


export const debug = createAction('[Editor] debug', props<{
  state: WidgetState
}>());
